import { JsonObject, JsonProperty } from 'json2typescript';
import SettingsModel from './SettingsModel';

@JsonObject('AppSettingsPassportModel')
export default class AppSettingsPassportModel {
  @JsonProperty('document_type', [SettingsModel])
  public documentType:SettingsModel[] = [];
  @JsonProperty('passport_type', [SettingsModel])
  public passportType:SettingsModel[] = [];
}